export default "__VITE_ASSET__1c3331f3__"